import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWrapper from './ModalWrapper';
import ModalCloseButton from './ModalCloseButton';
import Icon from './Icon';
import Button from './Button';

/**
 * 공통 안내/오류 모달 — window.alert() 대체용. 모노톤 브랜드 스타일.
 * SuccessAlertModal 의 오류/안내 버전. 보통 useAlertModal 훅과 함께 사용한다.
 *
 * Props:
 *   open: boolean — 표시 여부
 *   onClose: () => void
 *   title?: string — 헤더 (미지정 시 메시지만 노출)
 *   message?: string — 본문 (whitespace-pre-line 지원)
 *   variant?: 'error' | 'info'  (default 'error')
 *   confirmLabel?: string — 확인 버튼 (default '확인')
 */
export default function AlertModal({ open, onClose, title, message, variant = 'error', confirmLabel }) {
  const { t } = useTranslation();
  if (!open) return null;
  const iconName = variant === 'info' ? 'info' : 'alert';
  return (
    <ModalWrapper onClose={onClose} padding="p-5" gap="gap-4" maxWidth="max-w-[460px]" className="relative">
      <div className="absolute top-5 right-5">
        <ModalCloseButton onClick={onClose} />
      </div>
      <div className="flex flex-col items-center text-center gap-3 pt-2">
        <div className="w-14 h-14 rounded-full bg-mono-100 flex items-center justify-center">
          <Icon name={iconName} size={28} className="text-mono-700" />
        </div>
        {title && <h2 className="text-lg font-bold text-mono-900">{title}</h2>}
        {message && (
          <p className="text-sm text-mono-600 leading-relaxed break-keep whitespace-pre-line">{message}</p>
        )}
      </div>
      <Button level="dark" fullWidth onClick={onClose}>{confirmLabel || t('common.confirm')}</Button>
    </ModalWrapper>
  );
}
